/*
 * MMC: collapsible filter sidebar for the Suit collection toolbar (sections/main-collection.liquid, toolbar_style "suit").
 *
 * On desktop, "Filter by" toggles the sidebar instead of opening the filter drawer, as on the legacy theme. The state is
 * kept as a class on <html> (and in sessionStorage) so it survives the section re-render Prestige does when filtering.
 * On mobile the button keeps opening Prestige's filter drawer.
 */
(() => {
  if (window.__suitCollectionToggle) {
    return;
  }

  window.__suitCollectionToggle = true;

  const OPEN_CLASS = 'suit-filters-open';
  const STORAGE_KEY = 'suit-filters-open';
  const desktop = window.matchMedia('(min-width: 1000px)');

  const setOpen = (open) => {
    document.documentElement.classList.toggle(OPEN_CLASS, open);

    try {
      sessionStorage.setItem(STORAGE_KEY, open ? '1' : '0');
    } catch (error) {
      // Storage unavailable (private mode): the state simply won't persist across pages
    }
  };

  try {
    setOpen(sessionStorage.getItem(STORAGE_KEY) === '1');
  } catch (error) {
    setOpen(false);
  }

  // Capture phase, so the drawer opening handler of Prestige never sees the click on desktop
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.collection-toolbar--suit [aria-controls="facets-drawer"]');

    if (!button || !desktop.matches || !document.querySelector('.collection--suit-toggle')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    setOpen(!document.documentElement.classList.contains(OPEN_CLASS));
  }, { capture: true });
})();
